import { queryOptions, useQuery } from '@tanstack/react-query';

import { organizationsApi } from '../api/organizations-api';
import { summarizeOrganizations } from '../api/summary';

import { organizationKeys } from './organization-keys';

/** Console home numbers: walks the whole list (capped) and counts per status. */
export function organizationSummaryQueryOptions() {
  return queryOptions({
    queryKey: organizationKeys.summary(),
    queryFn: async () => {
      const { items, truncated } = await organizationsApi.listAll();
      return summarizeOrganizations(items, truncated);
    },
  });
}

export function useOrganizationSummary() {
  return useQuery(organizationSummaryQueryOptions());
}
